import React from "react";
import { Card, Col } from "react-bootstrap";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { useSelector } from "react-redux";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const RejectionVsApprovedChart = () => {
  const { claimDashboardData } = useSelector((state) => state.claimDashboard);
  const claimPayers = claimDashboardData?.claim_payor || [];

  // Extract payor names and amounts
  const payorNames = claimPayers.map((payer) => payer.payor_name);
  const approvedAmounts = claimPayers.map((payer) => payer.total_approveamount || 0);
  const rejectedAmounts = claimPayers.map((payer) => payer.total_rejectionamount || 0);

  // Calculate max y-axis value (round up to nearest 10000)
  const maxAmount = Math.max(
    ...approvedAmounts,
    ...rejectedAmounts,
    10000 // Minimum to avoid zero scaling
  );
  const yAxisMax = Math.ceil(maxAmount / 10000) * 10000;

  const data = {
    labels: payorNames,
    datasets: [
      {
        label: "Approved Amount",
        data: approvedAmounts,
        backgroundColor: "#28a745", // Green
      },
      {
        label: "Rejected Amount",
        data: rejectedAmounts,
        backgroundColor: "#dc3545", // Red
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "bottom",
      },
      tooltip: {
        callbacks: {
          label: (context) => `${context.dataset.label}: ${context.parsed.y.toLocaleString()} SR`,
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        min: 0,
        max: yAxisMax,
        ticks: {
          stepSize: yAxisMax / 5,
          callback: (value) => value.toLocaleString() + " SR",
        },
      },
      x: {
        ticks: {
          autoSkip: false,
          maxRotation: 45,
          minRotation: 45,
        },
      },
    },
  };

  return (
    <Col xs={12}>
      <Card className="p-3 h-100">
        <Card.Header className="p-3 fw-normal fs-9 text-primary">
          Rejection Amount vs Approved
        </Card.Header>
        <Card.Body style={{ height: "300px" }}>
          <Bar data={data} options={options} />
        </Card.Body>
      </Card>
    </Col>
  );
};

export default RejectionVsApprovedChart;